<template>
    <div class="badge" :class="badgeType"> {{ badgeContent || 'F' }} </div>
</template>

<script>
export default {
    props: {
        badgeContent: { },
        badgeType: {
            type: String,
            required: true,
            validator: val => ['vehicle', 'flag'].includes(val)
        }
    }
}
</script>

<style scoped>
.badge{
    position: absolute;
    color: black;
    border: 1px solid black;
    border-radius: 50%;
    margin-top: -18px;
    padding-right: 5px;
    padding-left: 5px;
    padding-top: 2px;
    padding-bottom: 2.5px;
    z-index: 2;
}
.vehicle{
    background: yellow;
    margin-left: 20px;
    font-size: 0.7em;
}
.flag{
    background: rgb(252, 28, 28);
    font-size: 0.65em;
}
</style>